export const MONTHS = [
  { value: 1, key: "common.month.january" },
  { value: 2, key: "common.month.february" },
  { value: 3, key: "common.month.march" },
  { value: 4, key: "common.month.april" },
  { value: 5, key: "common.month.may" },
  { value: 6, key: "common.month.june" },
  { value: 7, key: "common.month.july" },
  { value: 8, key: "common.month.august" },
  { value: 9, key: "common.month.september" },
  { value: 10, key: "common.month.october" },
  { value: 11, key: "common.month.november" },
  { value: 12, key: "common.month.december" },
];

export default MONTHS;



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/suppliersReports/enums/months.js